var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isJSEngineHermes, isPlatformReactNative } from '../utils/environment';
var HttpResponseFetchBodyParser = /** @class */ (function () {
    function HttpResponseFetchBodyParser() {
    }
    HttpResponseFetchBodyParser.prototype.parse = function (res) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var contentType, parsed, searchParams, _c, returnValue_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        contentType = (_b = (_a = res.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.toLowerCase().split(',')[0]) === null || _b === void 0 ? void 0 : _b.split(';')[0];
                        if (!(contentType === 'application/json')) return [3 /*break*/, 2];
                        return [4 /*yield*/, res.json()];
                    case 1:
                        parsed = (_d.sent());
                        return [3 /*break*/, 8];
                    case 2:
                        if (!(contentType === 'application/x-www-form-urlencoded')) return [3 /*break*/, 4];
                        _c = URLSearchParams.bind;
                        return [4 /*yield*/, res.text()];
                    case 3:
                        searchParams = new (_c.apply(URLSearchParams, [void 0, _d.sent()]))();
                        returnValue_1 = {};
                        searchParams.forEach(function (value, key) {
                            returnValue_1[key] = value;
                        });
                        parsed = returnValue_1;
                        return [3 /*break*/, 8];
                    case 4:
                        if (!(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith('image/'))) return [3 /*break*/, 6];
                        return [4 /*yield*/, res.arrayBuffer()];
                    case 5:
                        parsed = (_d.sent());
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, res.text()];
                    case 7:
                        parsed = (_d.sent());
                        _d.label = 8;
                    case 8:
                        HttpResponseFetchBodyParser.tryToDeregisterFromBlobRegistry(res);
                        return [2 /*return*/, parsed];
                }
            });
        });
    };
    HttpResponseFetchBodyParser.tryToDeregisterFromBlobRegistry = function (response) {
        var _a;
        // Hack to circumvent https://github.com/facebook/react-native/issues/30329
        try {
            if (isPlatformReactNative() && isJSEngineHermes()) {
                var bodyBlob = response._bodyBlob;
                if (typeof (bodyBlob === null || bodyBlob === void 0 ? void 0 : bodyBlob.close) === 'function') {
                    bodyBlob.close();
                }
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console -- we should not throw and fail the entire network op because of a failure here.
            (_a = console === null || console === void 0 ? void 0 : console.error) === null || _a === void 0 ? void 0 : _a.call(console, e);
            // ^ This will be reported for consumers of react-native-exception-handler:
            // https://github.com/a7ul/react-native-exception-handler/blob/50e736b0b2c39c2bf6f00f26a04d5073d69cf966/index.js#L17-L20
        }
    };
    return HttpResponseFetchBodyParser;
}());
export { HttpResponseFetchBodyParser };
